import React from 'react';
import PropTypes from 'prop-types';
import { DragLayer as dragLayer } from 'react-dnd';
import _ from 'lodash';

function collect(monitor) {
  return {
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  };
}

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '20%',
  height: '100%',
};

function getItemStyles(props) {
  const currentOffset = props.currentOffset;
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const x = currentOffset.x;
  const y = currentOffset.y;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

function getListStyles() {
  return {
    backgroundColor: '#dee3e8',
    border: '1px solid #E4E4E4',
    marginBottom: '5px',
    paddingLeft: '3px',
    cursor: 'move !important',
  };
}

function CardDragLayer(props) {

  const { items, isDragging } = props;
  if (!isDragging) {
    return false;
  }

  return (
    <div style={layerStyles}>
      <div className="drag-preview" style={getItemStyles(props)}>
        <ul>
          {_.map(items, (item, i) => (
            <li style={getListStyles()} key={i}>
              {item.n}
              <span className="draagable-tooltip-icon" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

CardDragLayer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isDragging: PropTypes.bool,
};

export default dragLayer(collect)(CardDragLayer);
